import gql from "graphql-tag";

export const MY_TIMESHEET_CREATE_COST = gql`
  mutation createMySheetCost(
    $name: String!
    $description: String!
    $value: Float!
    $billable: Boolean!
    $validFrom: Date
    $validTo: Date
  ) {
    createMySheetCost(
      name: $name
      description: $description
      value: $value
      billable: $billable
      validFrom: $validFrom
      validTo: $validTo
    ) {
      _id
      name
      description
      value
      billable
      color
      validFrom
      validTo
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      isDeleted
    }
  }
`;
